import script from "./MetaChart.vue?vue&type=script&setup=true&lang=js"
export * from "./MetaChart.vue?vue&type=script&setup=true&lang=js"

import "./MetaChart.vue?vue&type=style&index=0&id=1dc97a57&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dc97a57"]])

export default __exports__